import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';

@Component({
  selector: 'stat',
  templateUrl: './stat.component.html',
  styleUrls: ['./stat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatComponent {
  @Input() label: string;
  @Input() value: string;
  @Input() icon: IconComponent.Name | undefined;
  @Input() size: 'small' | 'medium' | 'medium-large' | 'large' = 'medium';
  @Input() emphasis: 'positive' | 'negative' | 'neutral' = 'neutral';

  valueClasses() {
    return ['value', this.size, this.emphasis];
  }
}
